"use strict";
import ActivityItemStore from "../stores/activity_item_store";
import Api from "../api/api";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import CarrierService from "../services/carrier_service";
import DocumentGroupStore from "../stores/document_group_store";
import DocumentsService from "./documents_service";
import EmailMessagesCache from "./email_messages_cache";
import FactoringAssignmentsStore from "../stores/factoring_assignments_store";
import FactoringCompaniesStore from "../stores/factoring_companies_store";
import FactoringCompanyOfficesStore from "../stores/factoring_company_offices_store";
import FactorBrokersStore from "../stores/factor_brokers_store";
import FactorInvoiceStore from "../stores/factor_invoices_store";
import Immutable from "immutable";
import LoadsStore from "../stores/loads_store";
import PaymentAddressesStore from "../stores/payment_addresses_store";
import TMSCustomerLoadsStore from "../stores/tms_customer_loads_store";
import TMSDeliveriesStore from "../stores/tms_deliveries_store";
import TMSStopsStore from "../stores/tms_stops_store";
import TMSShipmentsStore from "../stores/tms_shipments_store";
import VendorStore from "../stores/vendor_store";
import { emailService } from "../services/email_service";
import PineCache from "../util/pine/cache";
import ContactService from "./contact_service";
const DataStoreService = function() {
  const self = this;
  this.pineApp = null;
  this.setPineApp = function(pa) {
    self.pineApp = pa;
  };
  this.responseHandler = function(data) {
    self.updateStores(data);
    return data;
  };
  this.updatePineApp = function(data) {
    if (this.pineApp) {
      const { cache, fetchNeedsConfiguration } = this.pineApp.state.app;
      if (cache) {
        const updatedCacheData = PineCache.updatedCacheData(
          Immutable.fromJS(data.cacheable),
          fetchNeedsConfiguration,
          cache
        );
        this.pineApp.cacheUpdated(cache.set("data", updatedCacheData));
      }
    }
  };
  this.updateStores = function(data) {
    const result = {};
    if (data.cacheable) {
      this.updatePineApp(data);
    }
    if (data.contacts) {
      result.contacts = data.contacts.map((contact) => {
        return ContactService.contactService.updateContact(contact);
      });
    }
    if (data.account) {
      _.extend(Api.Account.current(), data.account);
      result.account = Api.Account.current();
    }
    if (data.document_page) {
      result.document_page = DocumentsService.replaceDocumentPage(
        data.document_page
      );
      $(self).trigger(
        "DataStoreService:documentPageReplaced",
        [result.document_page]
      );
    }
    if (data.document_groups) {
      result.document_groups = DocumentGroupStore.addOrUpdateAll(
        data.document_groups
      );
      $(self).trigger("DataStoreService:documentGroupUpdated");
    }
    if (data.documents) {
      result.documents = DocumentsService.updateDocuments(data.documents);
    }
    if (data.document_batch) {
      result.document_batch = DocumentsService.updateDocumentBatch(
        data.document_batch
      );
      $(self).trigger(
        "DataStoreService:documentBatchUpdated",
        [result.document_batch]
      );
    }
    if (data.summary_document_batches) {
      result.document_batches = data.summary_document_batches.map((d) => {
        return DocumentsService.updateDocumentBatch(d);
      });
    }
    if (data.document_batches) {
      result.document_batches = data.document_batches.map((d) => {
        const r = DocumentsService.updateDocumentBatch(d);
        $(self).trigger("DataStoreService:documentBatchUpdated", [r]);
        return r;
      });
    }
    if (data.email_messages) {
      emailService.updateFromData(data);
      result.email_messages = EmailMessagesCache.updateEmailMessages(
        data.email_messages
      );
    }
    if (data.document) {
      result.documents = DocumentsService.updateDocuments([data.document]);
    }
    if (data.load || data.loads) {
      const loads = data.loads || [data.load];
      result.loads = loads.map((load) => {
        const carrierInvoices = load.carrier_invoices || [];
        carrierInvoices.forEach((i) => CarrierInvoicesStore.addOrUpdate(i));
        return LoadsStore.addOrUpdate(load);
      });
    }
    if (data.carrier_invoice) {
      CarrierInvoicesStore.addOrUpdate(data.carrier_invoice);
    }
    if (data.carrier_invoices) {
      CarrierInvoicesStore.addOrUpdateAll(data.carrier_invoices);
    }
    if (data.carrier) {
      result.carriers = [
        CarrierService.carrierService.updateCarrier(data.carrier)
      ];
    }
    if (data.carriers) {
      result.carriers = CarrierService.carrierService.updateCarriers(
        data.carriers
      );
    }
    if (data.vendors) {
      VendorStore.addOrUpdateAll(data.vendors);
    }
    if (data.tms_shipments) {
      result.tms_shipments = TMSShipmentsStore.addOrUpdateAll(data.tms_shipments);
    }
    if (data.tms_customer_loads) {
      result.tms_customer_loads = TMSCustomerLoadsStore.addOrUpdateAll(data.tms_customer_loads);
    }
    if (data.tms_stops) {
      result.tms_stops = TMSStopsStore.addOrUpdateAll(data.tms_stops);
    }
    if (data.tms_deliveries) {
      result.tms_deliveries = TMSDeliveriesStore.addOrUpdateAll(data.tms_deliveries);
    }
    if (data.addresses) {
      result.factoring_companies = PaymentAddressesStore.addOrUpdateAll(data.addresses);
    }
    if (data.factoring_companies) {
      result.factoring_companies = FactoringCompaniesStore.addOrUpdateAll(data.factoring_companies);
    }
    if (data.factoring_company_offices) {
      result.factoring_company_offices = FactoringCompanyOfficesStore.addOrUpdateAll(
        data.factoring_company_offices
      );
    }
    if (data.factoring_assignments) {
      result.factoring_assignments = FactoringAssignmentsStore.addOrUpdateAll(data.factoring_assignments);
    }
    if (data.activity_items) {
      result.activity_items = ActivityItemStore.addOrUpdateAll(
        data.activity_items
      );
    }
    if (data.factor_invoice) {
      result.factor_invoices = [
        FactorInvoiceStore.addOrUpdate(data.factor_invoice)
      ];
      $(self).trigger("DataStoreService:factorInvoiceUpdated");
    }
    if (data.factor_invoices) {
      result.factor_invoices = FactorInvoiceStore.addOrUpdateAll(
        data.factor_invoices
      );
      $(self).trigger("DataStoreService:factorInvoiceUpdated");
    }
    if (data.factor_broker) {
      result.factor_brokers = [
        FactorBrokersStore.addOrUpdate(data.factor_broker)
      ];
      $(self).trigger("DataStoreService:factorBrokerUpdated");
    }
    if (data.factor_brokers) {
      result.factor_brokers = FactorBrokersStore.addOrUpdateAll(
        data.factor_brokers
      );
    }
    if (data.addDocumentToLoad) {
      $(self).trigger("DataStoreService:addDocumentToLoad", data.addDocumentToLoad);
    }
    if (data.ltlPayablesCarrierInvoiceSubmissionImport) {
      $(self).trigger(
        "DataStoreService:ltlPayablesCarrierInvoiceSubmissionImport",
        data.ltlPayablesCarrierInvoiceSubmissionImport
      );
    }
    return result;
  };
};
const dataStoreService = new DataStoreService();
export default dataStoreService;
